<template>
  <b-container fluid>
    <b-card>
      <div
        class="d-flex justify-content-start align-items-center position-relative"
      >
      <div class="filters-container">
        <b-form-select
          class="filter-select"
          v-model="selectedYear"
          :options="yearOptions"
          @change="updateFilter"
        />

        <b-form-select
          class="filter-select"
          v-model="selectedMonth"
          :options="monthOptions"
          @change="updateFilter"
        />

        <b-spinner
          v-if="isLoading"
          small
          variant="primary"
        />
      </div>


      </div>
    </b-card>
    <b-card>
      <RentTable
         ref="rentTable"
        :filteredRentData="filteredRentData"
        :rentData="rentData"
        :rentCharged="rentCharged"
        :rentPaid="rentPaid"
        :keysData="keysData"
        :formattedDate="formattedDate"
      />
    </b-card>
    <b-card>
      <TableTaxTM
        ref="tableTaxTm"
        :taxTmData="taxTmData"
        :rentChargedTm="rentChargedTm"
        :rentPaidTm="rentPaidTm"
        :keysDataTm="keysDataTm"
        :filteredTmData="filteredTmData"
        :formattedDate="formattedDate"
      />
    </b-card>
    <RentModal v-if="formattedDate" :formattedDate="formattedDate" />
    <TaxTmModal v-if="formattedDate" :formattedDate="formattedDate" />
  </b-container>
</template>

<script>
import { BContainer, BCard, BForm, BRow, BCol, BButton, BFormSelect, BAlert, BSpinner,} from "bootstrap-vue";
import RentModal from "./RentModal.vue";
import TaxTmModal from './TaxTmModal.vue';
import RentTable from "./RentTable.vue";
import TableTaxTM from "./TableTaxTM.vue";
import axios from "axios";
export default {
 data() {
  return {
    selectedYear: null,
    selectedMonth: null,
    isLoading: false,
    formattedDate: null,
    rentData: [],
    taxTmData: [],
    filteredRentData: [],
    filteredTmData: [],
    keysData: [],
    keysDataTm: [],
    rentCharged: 0,
    rentPaid: 0,
    rentChargedTm: 0,
    rentPaidTm: 0,
    yearOptions: [
      { value: null, text: "Selecione o ano..." },
      { value: 2025, text: "2025" },
      { value: 2026, text: "2026" },
    ],
    monthOptions: [
      { value: null, text: "Selecione o mês..." },
      { value: "01", text: "Janeiro" },
      { value: "02", text: "Fevereiro" },
      { value: "03", text: "Março" },
      { value: "04", text: "Abril" },
      { value: "05", text: "Maio" },
      { value: "06", text: "Junho" },
      { value: "07", text: "Julho" },
      { value: "08", text: "Agosto" },
      { value: "09", text: "Setembro" },
      { value: "10", text: "Outubro" },
      { value: "11", text: "Novembro" },
      { value: "12", text: "Dezembro" },
    ],
  };
},


  components: { BContainer, BCard, BForm, BRow, BCol, BButton, BFormSelect, BAlert, BSpinner, RentModal, RentTable, TableTaxTM, TaxTmModal,},
  methods: {
    updateFilter() {
      if (!this.selectedYear || !this.selectedMonth) return;

      this.isLoading = true;
      this.fetchAPI();
      this.$refs.rentTable?.ClearEc();
    },

    async fetchAPI() {
      try {
        this.formattedDate = `${this.selectedYear}-${this.selectedMonth}-01`;
        this.isLoading = true;

        const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH;
        const API_KEY = process.env.VUE_APP_API_KEY_THOTH;

        const response = await axios.get(`${BASE_URL}rent-validator`, {
          params: { date: this.formattedDate },
          headers: { "Api-Key": API_KEY },
        });

        const rentData = response.data.rent.data;
        const taxTmData = response.data.tm.data;

        this.rentCharged = response.data.rent.rentCharged;
        this.rentChargedTm = response.data.tm.rentCharged;

        this.rentPaid = response.data.rent.rentPaid;
        this.rentPaidTm = response.data.tm.rentPaid;

        this.rentData = this.flattenData(rentData);
        this.taxTmData = this.flattenData(taxTmData);

        this.filteredRentData = this.rentData;
        this.filteredTmData = this.taxTmData;

        this.keysDataTm = Object.keys(taxTmData);
        this.keysData = Object.keys(rentData);
      } catch (error) {
        console.log("Erro na requisição:", error);
      } finally {
        this.isLoading = false;
      }
    },

    flattenData(data) {
      let flattenedData = [];
      for (let establishmentName in data) {
        let transactions = data[establishmentName];
        transactions.forEach((transaction) => {
          flattenedData.push({
            establishmentId: transaction.establishmentId,
            name: transaction.name,
            balanceId: transaction.balanceId,
            type: transaction.type,
            description: transaction.description,
            date: transaction.date,
            available: transaction.available,
            waitingFunds: transaction.waitingFunds,
            balanceOldAmount: transaction.balanceOldAmount,
            amount: transaction.amount,
            fee: transaction.fee,
            netAmount: transaction.netAmount,
            balanceAmount: transaction.balanceAmount,
            paid: transaction.paid,
          });
        });
      }
      return flattenedData;
    },
  },
};
</script>
<style>
.filters-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-select {
  min-width: 260px;
}

</style>